import { settingsSlice } from '../slices';

export const { setIsSettingsLoading, setIsSettingUpdating, clearSettings } =
  settingsSlice.actions;
